import { PulseData } from '../Pulse/PulseData'
import { RaisedHand } from '../RaisedHand'
import { UserMic } from './UserMic'
import { useZoomContext } from '../../context/ZoomContext'
import { useSessionParams } from '../../hooks/useSessionParams'
export const MyUserVideo = () => {
    const { currentUserInfo: me } = useZoomContext()
    const { room } = useSessionParams()

    if (!me) return null

    return (
        <div className="user">
            <div className="top-left">
                <UserMic {...me} />
                <span>{me.displayName}</span>
            </div>
            <div className="top-right">
                <RaisedHand {...me} />
                {room === 'teams' && <PulseData {...me} />}
            </div>
        </div>
    )
}
